<template>
  <div class="merchant-application-detail">
    <div class="page-title application-detail-header">
      {{ $t('developer.application_setting') }}
    </div>

    <div v-if="!$store.getters.isID" class="application-detail-switch">
      <div class="grid-content bg-purple-light">
        <el-row class="switch-class">
          <el-col :span="5">
            <div class="grid-content bg-purple-light">
              <p class="setting-title"> {{ $t('developer.shared_application_setting') }}
                <el-tooltip placement="top">
                  <div slot="content" style="width: 300px">
                    <span>{{ $t('tips.shared_application_setting_tips') }}</span>
                  </div>
                  <svg-icon
                    icon-class="icon-blue-question"
                    class="icon-question-tip"
                  />
                </el-tooltip>
              </p>
            </div>
          </el-col>
          <el-col :span="19">
            <template>
              <el-switch
                v-model="sharePublicKeyStatus"
                :active-value="1"
                :inactive-value="2"
                :active-text="sharePublicKeyStatus===1?'Open':'Close'"
                active-color="#67C23A"
                inactive-color="#F56C6C"
                :disabled="!publicKeyFlag"
                @change="changeSharePublicKeyStatus"
              />
            </template>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="application-detail-application">
      <el-row>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <p class="setting-title">
              {{ $t('developer.application_information') }}
            </p>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="5">
                <div class="grid-content bg-purple">
                  <p class="setting-key">AppId:</p>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content bg-purple">
                  <p class="setting-value">{{ application.app_id }}</p>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple" />
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="application-detail-webhook">
      <el-row>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <p class="setting-title">Webhook</p>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="5">
                <div class="grid-content bg-purple">
                  <p class="setting-key">Pay out:</p>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content bg-purple">
                  <p v-if="!noticeWebhookFlag" class="setting-value">{{ application.notice_webhook ? application.notice_webhook : '' }}</p>&nbsp;
                  <el-input v-if="noticeWebhookFlag" v-model="webhookForm.notice_webhook" class="search-frame" :placeholder="$t('merchant.notice_webhook')" />
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ $t('components.edit') }}</span> <br>
                    </div>
                    <i v-if="!noticeWebhookFlag" class="el-icon-edit setting-value icon-hover" @click="changeWebhookInput(1)" />&nbsp;
                  </el-tooltip>

                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ $t('components.submit') }}</span> <br>
                    </div>
                    <el-button v-if="noticeWebhookFlag" type="primary" class="submit-btn" icon="el-icon-edit" circle @click="submitMchWebhook(1)" />
                  </el-tooltip>

                </div>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="7"><div class="grid-content bg-purple">
                <p class="setting-key">Static VA:</p>
              </div></el-col>
              <el-col :span="14"><div class="grid-content bg-purple">
                <p v-if="!collectUrlFlag" class="setting-value">{{ application.collect_url ? application.collect_url : '' }}</p>&nbsp;
                <el-input v-if="collectUrlFlag" v-model="webhookForm.collect_url" class="search-frame" />
              </div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple">

                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.edit') }}</span> <br>
                  </div>
                  <i v-if="!collectUrlFlag" class="el-icon-edit setting-value icon-hover" @click="changeWebhookInput(2)" />&nbsp;
                </el-tooltip>

                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.submit') }}</span> <br>
                  </div>
                  <el-button v-if="collectUrlFlag" type="primary" class="submit-btn" icon="el-icon-edit" circle @click="submitMchWebhook(2)" />
                </el-tooltip>

              </div></el-col>
            </el-row>
            <el-row>
              <el-col :span="7"><div class="grid-content bg-purple">
                <p class="setting-key">Web Payment:</p>
              </div></el-col>
              <el-col :span="14"><div class="grid-content bg-purple">
                <p v-if="!qrWebhookFlag" class="setting-value">{{ application.dynamic_webhook ? application.dynamic_webhook : '' }}</p>&nbsp;
                <el-input v-if="qrWebhookFlag" v-model="webhookForm.dynamic_webhook" class="search-frame" />
              </div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple">

                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.edit') }}</span> <br>
                  </div>
                  <i v-if="!qrWebhookFlag" class="el-icon-edit setting-value icon-hover" @click="changeWebhookInput(3)" />&nbsp;
                </el-tooltip>

                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.submit') }}</span> <br>
                  </div>
                  <el-button v-if="qrWebhookFlag" type="primary" class="submit-btn" icon="el-icon-edit" circle @click="submitMchWebhook(3)" />
                </el-tooltip>

              </div></el-col>
            </el-row> -->

            <!--Static VA -->
            <el-row v-if="$store.getters.isID">
              <el-col :span="7"><div class="grid-content bg-purple">
                <p class="setting-key">Static VA Collection Verification URL:</p>
              </div></el-col>
              <el-col :span="14"><div class="grid-content bg-purple">
                <p v-if="!staticVAFlag" class="setting-value">{{ application.validate_url ? application.validate_url : '' }}</p>&nbsp;
                <el-input v-if="staticVAFlag" v-model="webhookForm.validate_url" class="search-frame" />
              </div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple">

                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.edit') }}</span> <br>
                  </div>
                  <i v-if="!staticVAFlag" class="el-icon-edit setting-value icon-hover" @click="changeWebhookInput(4)" />&nbsp;
                </el-tooltip>

                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('components.submit') }}</span> <br>
                  </div>
                  <el-button v-if="staticVAFlag" type="primary" class="submit-btn" icon="el-icon-edit" circle @click="submitMchWebhook(4)" />
                </el-tooltip>

              </div></el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="application-detail-apiKey">
      <el-row>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <p class="setting-title">API Key</p>
            <div style="width: 80%; margin-top: 20px">
              <p class="setting-title-dec">{{ $t('tips.public_key_introduce') }}</p>

            </div>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="5">
                <div class="grid-content bg-purple-light">
                  <p class="setting-key"> {{ $t('developer.public_key') }}:</p>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content bg-purple-light">
                  <p v-if="!publicKeyInputFlag" class="setting-value">{{ hiddenInfo.public_key }}</p>
                  <el-input
                    v-if="publicKeyInputFlag"
                    v-model="hiddenForm.public_key"
                    type="textarea"
                    :rows="8"
                    clearable
                  />
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple-light">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ $t('components.view') }}</span> <br>
                    </div>
                    <i v-if="!publicKeyFlag" class="el-icon-view setting-value icon-hover" @click="showUserAuthenticationModal('public_key_second')" />
                  </el-tooltip>

                  <i v-if="publicKeyFlag && !publicKeyInputFlag" class="el-icon-edit setting-value icon-hover" @click="changeHiddenInput(1)" />
                  <el-button v-if="publicKeyInputFlag" type="primary" class="submit-btn" icon="el-icon-edit" circle @click="submitReSetPublicSecret(1)" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="application-detail-ip">
      <el-row>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <p class="setting-title">{{ $t('developer.ip_white_list') }}
              <el-tooltip placement="top">
                <div slot="content" style="width: 300px">
                  <span>{{ $t('tips.ip_white_paycools_introduce') }}</span>
                </div>
                <svg-icon
                  icon-class="icon-blue-question"
                  class="icon-question-tip"
                />
              </el-tooltip>
            </p>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="5">
                <div class="grid-content bg-purple-light">
                  <p class="setting-key">{{ $t('developer.ip_address') }}:</p>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content bg-purple-light">
                  <p v-if="!ipKeyInputFlag" class="setting-value">{{ hiddenInfo.white_ips }}</p>
                  <!--                  <el-input-->
                  <!--                    v-if="ipKeyInputFlag"-->
                  <!--                    v-model="hiddenForm.white_ips"-->
                  <!--                    clearable-->
                  <!--                  />-->
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple-light">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ $t('components.view') }}</span> <br>
                    </div>
                    <i v-if="!ipKeyFlag" class="el-icon-view icon-hover" @click="showUserAuthenticationModal('white_ips_second')" />
                  </el-tooltip>
                  <!--                  <i v-if="ipKeyFlag && !ipKeyInputFlag" class="el-icon-edit icon-hover" @click="changeHiddenInput(2)" />-->
                  <!--                  <el-button v-if="ipKeyInputFlag" type="primary" class="submit-btn" icon="el-icon-edit" circle @click="submitReSetWhiteIps" />-->
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :title="$t('developer.shared_application_setting')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="closeSharePublicKeyDialog"
    >
      <p style="margin-bottom: 50px">{{ $t('tips.share_public_key_introduce') }}</p>

      <!--      <p style="margin-bottom: 20px">Pay out</p>-->
      <!--      <el-input v-model="hiddenInfo.notice_webhook" type="textarea" :rows="1" style="margin-bottom: 20px"/>-->

      <!--      <p style="margin-bottom: 20px">{{ $t('developer.ip_address') }}</p>-->
      <!--      <el-input v-model="hiddenInfo.white_ips" type="textarea" :rows="2" style="margin-bottom: 20px"/>-->

      <!--      <el-form ref="form" :model="form">-->
      <!--        <p style="margin-bottom: 20px">{{ $t('developer.public_key') }}</p>-->

      <!--        <el-form-item>-->
      <!--          <el-input v-model="hiddenInfo.public_key" type="textarea" :rows="10" />-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSharePublicKeyDialog">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" @click="submitSharePublicKey()">{{ $t('components.confirm') }}</el-button>
      </div>
    </el-dialog>

    <AppIdentityEmailCheckModal ref="identityCheckPublicKeyRef" :app_id_second="checkType" @showHiddenInfo="showHiddenInfo" />
    <AppIdentityEmailCheckModal ref="identityCheckWhiteIpsRef" :app_id_second="checkType" @showHiddenInfo="showHiddenInfo" />
  </div>
</template>

<script>

import { fetchMerchantAppList, updateMerchantAppEvent, reSetSecret, reSetPublicSecret, reSetMchAppWhiteIps, updateSharePublicConfig } from '@/api/merchant-manage/merchant-manage'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'
import { WEB_HOOK } from '@/const/const'

export default {
  name: 'Develop_Manage_App_Detail',
  components: {
    // ApplicationIdentityCheckModal: () => import('./components/Modal/ApplicationIdentityCheckModal')
    AppIdentityEmailCheckModal: () => import('./components/Modal/AppIdentityEmailCheckModal')
  },
  data() {
    return {
      application: {},
      sharePublicKeyStatus: 1,
      dialogVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      hiddenInfo: {
        public_key: '********',
        secret_key: '********',
        white_ips: '********'
      },
      checkType: '',
      webhookForm: {
        collect_url: '',
        dynamic_webhook: '',
        validate_url: '',
        notice_webhook: ''
      },
      sharePublicKeyForm: {
        share_public_key_status: '',
        public_key: ''
      },
      hiddenForm: {
        id: '',
        public_key: '',
        white_ips: ''
      },
      mfaForm: {
        msg_code: ''
      },
      form: {
        name: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      noticeWebhookFlag: false,
      qrWebhookFlag: false,
      publicKeyFlag: false,
      secretKeyFlag: false,
      ipKeyFlag: false,
      publicKeyInputFlag: false,
      secretKeyInputFlag: false,
      ipKeyInputFlag: false,
      collectUrlFlag: false,
      staticVAFlag: false
    }
  },
  mounted() {
    this.getMerchantAppList()
  },
  methods: {
    getMerchantAppList() {
      fetchMerchantAppList().then(res => {
        const record = res.data
        const that = this
        record.forEach(function(item, index) {
          if (index === 0) {
            that.application = item
            that.sharePublicKeyStatus = item.share_public_key_status || 2
          }
        })
      })
    },
    changeSharePublicKeyStatus(row) {
      if (this.sharePublicKeyStatus === 1) {
        this.dialogVisible = true
        return
      }
      const params = {
        share_public_key_status: 2
      }
      updateSharePublicConfig(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
        }
      })
    },
    closeSharePublicKeyDialog() {
      this.hiddenInfo.public_key = this.sharePublicKeyForm.public_key
      this.sharePublicKeyStatus = 2
      this.dialogVisible = false
    },
    submitSharePublicKey(row) {
      // this.hiddenInfo.public_key = this.hiddenInfo.public_key.trim()
      // if (!this.hiddenInfo.public_key || !this.hiddenInfo.notice_webhook || !this.hiddenInfo.white_ips) {
      //   return this.$message.warning(this.$t('tips.share_public_key_empty'))
      // }
      // this.$confirm(this.$t('tips.share_public_key_to_verify'), 'Tips', {
      //   confirmButtonText: this.$t('components.confirm'),
      //   cancelButtonText: this.$t('components.cancel'),
      //   type: 'warning'
      // }).then(() => {
      const params = {
        share_public_key_status: this.sharePublicKeyStatus,
        public_key: cryptoJSAesEncrypt(this.hiddenInfo.public_key),
        notice_webhook: this.application.notice_webhook
        // white_ips: this.hiddenInfo.white_ips
      }
      updateSharePublicConfig(params).then(res => {
        if (res.code === 10000) {
          this.sharePublicKeyForm.public_key = this.hiddenInfo.public_key
          this.$message.success('Success')
          this.dialogVisible = false
          this.getMerchantAppList()
        }
      })
      // })
    },

    changeWebhookInput(index) {
      this.webhookForm.app_id = this.application.app_id
      this.webhookForm.notice_webhook = this.webhookForm.notice_webhook ? this.webhookForm.notice_webhook : this.application.notice_webhook
      this.webhookForm.payout_webhook = this.webhookForm.payout_webhook ? this.webhookForm.payout_webhook : this.application.payout_webhook
      this.webhookForm.collect_url = this.webhookForm.collect_url ? this.webhookForm.collect_url : this.application.collect_url
      this.webhookForm.dynamic_webhook = this.webhookForm.dynamic_webhook ? this.webhookForm.dynamic_webhook : this.application.dynamic_webhook
      this.webhookForm.validate_url = this.webhookForm.validate_url ? this.webhookForm.validate_url : this.application.validate_url

      if (WEB_HOOK.PAY_OUT === index) {
        this.noticeWebhookFlag = true
      }
      if (WEB_HOOK.STATIC_CODE === index) {
        this.collectUrlFlag = true
      }
      if (WEB_HOOK.DYNAMIC_ORDER === index) {
        this.qrWebhookFlag = true
      }
      if (WEB_HOOK.STATIC_VA === index) {
        this.staticVAFlag = true
      }
    },
    changeHiddenInput(index) {
      this.hiddenForm.id = this.application.app_id
      if (index === 1) {
        this.publicKeyInputFlag = true
        this.hiddenForm.public_key = this.hiddenInfo.public_key
      }
      if (index === 2) {
        this.ipKeyInputFlag = true
        this.hiddenForm.white_ips = this.hiddenInfo.white_ips
      }
    },
    submitMchWebhook(index) {
      const { collect_url, dynamic_webhook, validate_url, notice_webhook } = this.webhookForm
      if (!collect_url && !dynamic_webhook && !validate_url && !notice_webhook) {
        this.$message.warning('Merchant callback interfaces cannot be NULL')
        return
      }
      let msg = this.sharePublicKeyStatus === 1 ? this.$t('tips.share_public_key_to_verify') : this.$t('tips.share_public_webhook_to_update')
      if (this.$store.getters.isMX || this.$store.getters.isID) {
        msg = this.$t('tips.share_public_webhook_to_update')
      }
      this.$confirm(msg, 'Tips', {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        updateMerchantAppEvent(this.webhookForm).then(res => {
          this.$message.success('Update Successfully')
          if (index === 1) {
            this.noticeWebhookFlag = false
          }
          if (index === 3) {
            this.qrWebhookFlag = false
          }
          if (index === 2) { this.collectUrlFlag = false }
          if (WEB_HOOK.STATIC_VA === index) { this.staticVAFlag = false }
          this.getMerchantAppList()
        })
      })
    },
    showUserAuthenticationModal(type) {
      this.checkType = type
      if (this.application.app_id) {
        if (type === 'public_key_second') {
          this.$refs.identityCheckPublicKeyRef.changModalStatus(true, this.application.app_id)
        }
        if (type === 'white_ips_second') {
          this.$refs.identityCheckWhiteIpsRef.changModalStatus(true, this.application.app_id)
        }
      }
    },
    showHiddenInfo(value) {
      if (value.check_status) {
        // this.hiddenInfo.secret_key = value.secret
        this.hiddenInfo.public_key = value.public_key
        this.hiddenInfo.white_ips = value.white_ips

        this.sharePublicKeyForm.share_public_key_status = this.sharePublicKeyStatus
        this.sharePublicKeyForm.public_key = value.public_key

        this.publicKeyFlag = true
        this.secretKeyFlag = true
        this.ipKeyFlag = true
      }
    },
    submitReSetSecret() {
      this.$confirm('Did you want to re-set Secret Key?', 'Tips', {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        const params = { id: this.application.app_id }
        reSetSecret(params).then(res => {
          this.$message.success('Success')
          // this.hiddenInfo.secret_key = res.data.secret
        })
      })
    },
    submitReSetPublicSecret() {
      let msg = this.sharePublicKeyStatus === 1 ? this.$t('tips.share_public_key_to_verify') : this.$t('tips.share_public_key_to_update')
      if (this.$store.getters.isMX || this.$store.getters.isID) {
        msg = this.$t('tips.share_public_key_to_update')
      }
      this.$confirm(msg, 'Tips', {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          app_id: this.hiddenForm.id,
          public_key: cryptoJSAesEncrypt(this.hiddenForm.public_key)
        }
        reSetPublicSecret(params).then(res => {
          this.$message.success('Success')
          this.hiddenInfo.public_key = this.hiddenForm.public_key
          this.publicKeyInputFlag = false
        })
      })
    },
    submitReSetWhiteIps() {
      if (!this.validateIPAddresses(this.hiddenForm.white_ips)) {
        return
      }
      let msg = this.sharePublicKeyStatus === 1 ? this.$t('tips.share_public_key_to_verify') : this.$t('tips.share_public_ip_to_update')
      if (this.$store.getters.isMX || this.$store.getters.isID) {
        msg = this.$t('tips.share_public_ip_to_update')
      }
      this.$confirm(msg, 'Tips', {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          app_id: this.hiddenForm.id,
          white_ips: this.hiddenForm.white_ips
        }

        reSetMchAppWhiteIps(params).then(res => {
          this.$message.success('Success')
          this.hiddenInfo.white_ips = this.hiddenForm.white_ips
          this.ipKeyInputFlag = false
        })
      })
    },
    validateIPAddresses(value) {
      if (/\s/g.test(value)) {
        this.$message.warning('The input value cannot contain spaces')
        return false
      }
      const ipRegex = /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}(\/(3[0-2]|[1-2]?\d))?)(,\s*((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}(\/(3[0-2]|[1-2]?\d))?))*$/
      if (!ipRegex.test(value)) {
        this.$message.warning('Please enter a valid IP address, separated by commas')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-question-tip {
  position: relative;
  top: -1px;
  font-size: 12px;
  color: #3855F1;
  height: 20px;
  line-height: 20px;
}
  .el-col{
    min-height:1px;
  }
  .search-frame {
    width: 550px;
    margin: 5px;
  }
  .submit-btn {
    margin: 5px;
  }
  .merchant-application-detail{
    margin: 48px;
    background: #fff;
    border-radius: 4px;
  }
  .application-detail-header {
    width: 100%;
    height: 79px;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-switch {
    width: 100%;
    min-height: 50px;
    padding: 0 0 20px;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-application {
    width: 100%;
    min-height: 50px;
    padding: 24px 0;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-webhook {
    width: 100%;
    min-height: 140px;
    padding: 24px 0;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-apiKey {
    width: 100%;
    min-height: 170px;
    padding: 24px 0;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-ip {
    width: 100%;
    padding: 24px 0;
  }
  p {margin: 0}
  .setting-title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #3855F1;
  }
  .setting-key {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 36px;
    color: #98A1B4;
  }
  .setting-value {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 36px;
    color: #4B5567;
    word-break: break-all;
  }
  .setting-title-dec {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #98A1B4;
  }
  .icon-hover{
   cursor: pointer;
  }
  .icon-hover:hover {
    font-size: 22px;
    color: #3855F1;
  }
  .switch-class{
    display: flex;
    align-items: center;
  }
  .underline {
    display: inline-block;
    width: 100%;
    border-bottom: 1px solid black;
  }
</style>
